import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router";

import { getErrorMessage } from "helpers";
import { getPage, Page, initialPage, putPage, postPage } from "services/pages";
import { Image } from "services/images";

export const usePagePage = (id: number) => {
  const history = useHistory();
  const [formData, setFormData] = useState<Page>(initialPage);

  // Fetch data
  useEffect(() => {
    (async () => {
      if (id > 0) {
        try {
          const data = await getPage(id);
          setFormData(data);
        } catch (e) {
          toast.error(getErrorMessage(e));
          console.error(e);
        }
      }
    })();
  }, [id]);

  const inputChanged = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const name = e.target.name;
    const value = e.target.value;

    setFormData((old) => ({ ...old, [name]: value }));
  };

  const onFileChange = (image: Image | null) => {
    setFormData((old) => ({ ...old, image }));
  };

  const onRichTextChange = (value: string, name: string) => {
    setFormData((old) => ({ ...old, [name]: value }));
  };

  const onFormSave = async (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();

    // POST
    if (formData.id < 0) {
      try {
        const newPage = await postPage(formData);
        history.push(`/pages/${newPage.id}`);
        toast.success("Page saved.");
      } catch (e) {
        toast.error(getErrorMessage(e));
        console.error(e);
      }
      return;
    }

    // PUT
    try {
      const newPage = await putPage(formData);
      setFormData(newPage);
      toast.success("Page saved.");
    } catch (e) {
      toast.error(getErrorMessage(e));
      console.error(e);
    }
  };

  return {
    formData,
    inputChanged,
    onFileChange,
    onFormSave,
    onRichTextChange,
  };
};
